import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { MapPin } from 'lucide-react';

// Fix for default marker icons in React-Leaflet
import L from 'leaflet';
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const locations = [
  {
    name: 'Bwindi Impenetrable Forest',
    coordinates: [-1.0724, 29.6777],
    description: 'Mountain gorilla trekking'
  },
  {
    name: 'Murchison Falls',
    coordinates: [2.2742, 31.6811],
    description: 'Wildlife safaris and waterfall'
  },
  {
    name: 'Queen Elizabeth National Park',
    coordinates: [-0.1962, 29.8897],
    description: 'Tree-climbing lions and boat safaris'
  },
  {
    name: 'Kibale Forest',
    coordinates: [0.4636, 30.3561],
    description: 'Chimpanzee tracking'
  },
  {
    name: 'Jinja',
    coordinates: [0.4478, 33.2027],
    description: 'Adventure activities and source of the Nile'
  }
];

const InteractiveMap = () => {
  return (
    <section className="relative py-12 overflow-hidden bg-gray-900">
      {/* Map Background */}
      <div className="absolute inset-0 z-0">
        <MapContainer 
          center={[1.3733, 32.2903]} 
          zoom={6} 
          style={{ height: '100%', width: '100%' }}
          zoomControl={false}
          attributionControl={false}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {locations.map((location, index) => (
            <Marker key={index} position={location.coordinates as [number, number]}>
              <Popup>
                <div className="p-2">
                  <h3 className="font-semibold text-gray-900">{location.name}</h3>
                  <p className="text-sm text-gray-600">{location.description}</p>
                </div>
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>

      {/* Content Overlay */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 shadow-xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Explore Uganda's Destinations
              </h2>
              <p className="text-gray-600 mb-6">
                From mountain gorillas in Bwindi to the thundering Murchison Falls, discover the diverse 
                landscapes and incredible wildlife of Uganda. Click on the markers to learn more about 
                each destination.
              </p>
              <div className="space-y-4">
                {locations.map((location, index) => (
                  <div key={index} className="flex items-start">
                    <MapPin className="h-5 w-5 text-ta-green mt-1 flex-shrink-0" />
                    <div className="ml-3">
                      <h3 className="font-medium text-gray-900">{location.name}</h3>
                      <p className="text-sm text-gray-600">{location.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative h-[400px] rounded-lg overflow-hidden shadow-lg border border-gray-200">
              <MapContainer 
                center={[1.3733, 32.2903]} 
                zoom={6} 
                style={{ height: '100%', width: '100%' }}
              >
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
                {locations.map((location, index) => (
                  <Marker key={index} position={location.coordinates as [number, number]}>
                    <Popup>
                      <div className="p-2">
                        <h3 className="font-semibold text-gray-900">{location.name}</h3>
                        <p className="text-sm text-gray-600">{location.description}</p>
                      </div>
                    </Popup>
                  </Marker>
                ))}
              </MapContainer>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InteractiveMap;